<template>

    <div class="profile-dashboard__info">

        <div class="profile-dashboard__info-content">
            <div class="profile-dashboard__info-title">
                {{$store.getters.t('user_dashboard_hello_prefix')}} {{user.name}}{{$store.getters.t('user_dashboard_hello_suffix')}}
            </div>
            <div class="profile-dashboard__info-description">
                {{$store.getters.t('user_dashboard_thank_you')}}<br>
                {{$store.getters.t('user_dashboard_last_month')}}
                <span>
                    {{(dashboard && dashboard['last_month_raised']) || 0}} USD
                </span>
                {{$store.getters.t('user_dashboard_raised_for_animals')}}
            </div>

        </div>

    </div>

</template>

<script>
export default {
    name: "UserDashboardInfo",
    props: ['user', 'dashboard'],

}
</script>

<style scoped>

</style>
